module.exports = __webpack_public_path__ + "img/student-membership.e3a2b032.svg";